import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/shared/config/routes";
import { isMockApi } from "@/shared/config/apiBase";
import { subscribeCredit4uPasswordExpired } from "@/shared/auth/codefPasswordEvents";
import { useAlertDialog } from "@/shared/hooks/useSystemUI";
import Credit4uPasswordExpirySheet from "./Credit4uPasswordExpirySheet";

/**
 * 신용정보원(credit4u) 비밀번호 만료 이벤트(shared/auth 버스)를 구독해
 * 전역 안내 시트를 열고 [변경하기] 선택 시 갱신 화면으로 이동한다.
 *
 * 버스가 armed-generation latch 로 중복 발화를 이미 차단하므로, 여기서는
 * 통지받은 이벤트를 그대로 open 하면 된다(추가 dedup 불필요).
 *
 * AuthSessionRecovery 와 동일한 headless 구독 컴포넌트 패턴 — Router(BrowserRouter) 내부에
 * 마운트되어야 useNavigate 가 동작한다.
 */
const Credit4uPasswordExpiryRecovery = () => {
  const navigate = useNavigate();
  const { open: showAlert } = useAlertDialog();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(
    () => subscribeCredit4uPasswordExpired(() => setIsOpen(true)),
    [],
  );

  const handleChangePassword = () => {
    setIsOpen(false);
    // mock 환경 차단 — 갱신은 실 API 전용 기능이다(renewal-pwd 실 호출만 존재, mock 없음).
    // API base 가 없는 mock 환경에서 진입시키면 상대경로 404 로 떨어지는 dead form 이 되므로
    // 시트 자체는 유지하되 [변경하기]만 막는다(만료 신호는 mock 재동기화 잡이 재현할 수 있다).
    if (isMockApi()) {
      showAlert({
        title: "실 API 환경에서만 지원해요",
        message: "mock 환경에서는 비밀번호 변경을 진행할 수 없어요.",
      });
      return;
    }
    navigate(ROUTES.CREDIT_PASSWORD_RENEWAL);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Credit4uPasswordExpirySheet
      isOpen={isOpen}
      onChangePassword={handleChangePassword}
      onCancel={handleCancel}
    />
  );
};

export default Credit4uPasswordExpiryRecovery;
